// extracted by mini-css-extract-plugin
export default {"SwitchToggle":"SwitchToggle_SwitchToggle__9n-aY","Toggle":"SwitchToggle_Toggle__847KU","ToggleActive":"SwitchToggle_ToggleActive__9xxH3"};